import React from 'react';
import ReactDOM from 'react-dom';
import SubscribePageContent from './SubscribePageContent';

if (document.getElementById("SubscribeJson") !== null) {
    var subscribeJson = JSON.parse(document.getElementById("SubscribeJson").textContent); // eslint-disable-next-line
    var yearsListJson = JSON.parse(document.getElementById("yearsListJson").textContent); // eslint-disable-next-line
    var salonCountriesJson = JSON.parse(document.getElementById("salonCountriesJson").textContent); // eslint-disable-next-line
    ReactDOM.render(<SubscribePageContent subscribe={subscribeJson.Model} yearsList={yearsListJson} salonCountries={salonCountriesJson} />, document.getElementById('SubscribePageIndex'));
}

